import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Working Definiton of Antisemitism`}</h2>
    <h3>{`2. Protecting Jewish Users`}</h3>
    <p><strong parentName="p">{`2.1`}</strong>{` `}<strong parentName="p">{`The Working Definition`}</strong>{`: "Antisemitism is a certain perception of Jews, which may be expressed as hatred toward Jews. Rhetorical and physical manifestations of antisemitism are directed toward Jewish or non-Jewish individuals and/or their property, toward Jewish community institutions and religious facilities."`}</p>
    <p><strong parentName="p">{`2.2`}</strong>{` To guide IHRA in its work, the following examples may serve as illustrations:`}</p>
    <p>{`Manifestations might include the targeting of the state of Israel, conceived as a Jewish collectivity. However, criticism of Israel similar to that leveled against any other country cannot be regarded as antisemitic. Antisemitism frequently charges Jews with conspiring to harm humanity, and it is often used to blame Jews for “why things go wrong.” It is expressed in speech, writing, visual forms and action, and employs sinister stereotypes and negative character traits.`}</p>
    <p>{`Contemporary examples of antisemitism in public life, the media, schools, the workplace, and in the religious sphere could, taking into account the overall context, include, but are not limited to:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Calling for, aiding, or justifying the killing or harming of Jews in the name of a radical ideology or an extremist view of religion.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Making mendacious, dehumanizing, demonizing, or stereotypical allegations about Jews as such or the power of Jews as collective — such as, especially but not exclusively, the myth about a world Jewish conspiracy or of Jews controlling the media, economy, government or other societal institutions.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Accusing Jews as a people of being responsible for real or imagined wrongdoing committed by a single Jewish person or group, or even for acts committed by non-Jews.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Denying the fact, scope, mechanisms (e.g. gas chambers) or intentionality of the genocide of the Jewish people at the hands of National Socialist Germany and its supporters and accomplices during World War II (the Holocaust`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Accusing the Jews as a people, or Israel as a state, of inventing or exaggerating the Holocaust.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Accusing Jewish citizens of being more loyal to Israel, or to the alleged priorities of Jews worldwide, than to the interests of their own nations.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Denying the Jewish people their right to self-determination, e.g., by claiming that the existence of a State of Israel is a racist endeavor.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Applying double standards by requiring of it a behavior not expected or demanded of any other democratic nation.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Using the symbols and images associated with classic antisemitism (e.g., claims of Jews killing Jesus or blood libel) to characterize Israel or Israelis.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Drawing comparisons of contemporary Israeli policy to that of the Nazis.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Holding Jews collectively responsible for actions of the state of Israel.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Antisemitic acts are criminal when they are so defined by law (for example, denial of the Holocaust or distribution of antisemitic materials in some countries).`}</p>
      </li>
    </ul>
    <p><strong parentName="p">{`2.3`}</strong>{` `}<strong parentName="p">{`Criminal acts`}</strong>{` are antisemitic when the targets of attacks, whether they are people or property – such as buildings, schools, places of worship and cemeteries – are selected because they are, or are perceived to be, Jewish or linked to Jews.`}</p>
    <p><strong parentName="p">{`2.4`}</strong>{` `}<strong parentName="p">{`Antisemitic discrimination`}</strong>{` is the denial to Jews of opportunities or services available to others and is illegal in many countries.`}</p>
    <p><strong parentName="p">{`2.5`}</strong>{` HostJane will endeavor to keep this page updated in line with the IHRA definition of Antisemitism therein: `}<a parentName="p" {...{
        "href": "https://www.holocaustremembrance.com/resources/working-definitions-charters/working-definition-antisemitism"
      }}>{`https://www.holocaustremembrance.com/resources/working-definitions-charters/working-definition-antisemitism`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      